<template>
  <v-card
    class="mx-auto my-4 fill-height"
    elevation="6"
    style="width: 100%;"
    variant="flat"
    rounded="0"
    :color="isCalculated ? 'surface-bright' : 'surface-light'"
  >
    <v-card-title v-if="isCalculated" class="d-flex justify-center">
      <span class="text-h5 text-sm-h4 text-md-h3 text-wrap lh-base text-on-surface-bright font-weight-bold">
        Total Potential Taxes: <br /> With Adjustments <sup>2</sup>
      </span>
    </v-card-title>
    <v-card-title v-else class="d-flex justify-center">
      <span class="text-h5 text-sm-h4 text-md-h3 text-wrap lh-base text-on-surface-light font-weight-bold">
        Total Potential Taxes: <br /> Existing Approach <sup>1</sup>
      </span>
    </v-card-title>

    <v-card-text v-if="isCalculated" class="pt-4 px-5 text-center d-flex">
      <v-row>
        <v-col class="bg-background elevation-10">
          <span class="text-h3 text-sm-h2 text-md-h1 text-on-background">{{ formatCurrency(store.user.totalTaxesConversion) }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else class="pt-4 px-5 text-center d-flex">
      <v-row>
        <v-col class="bg-background elevation-10">
          <span class="text-h3 text-sm-h2 text-md-h1 text-on-background">{{ formatCurrency(store.user.taxPaid) }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useLeadGeneratorStore } from '@/stores/leadGenerator'
import { formatCurrency } from '@/utils/formatters'

defineProps({
  isCalculated: {
    type: Boolean,
    default: false,
  },
})

const store = useLeadGeneratorStore()
</script>
